import React, {forwardRef, useImperativeHandle, useRef} from 'react'
import HintPopover from "../../../../core/gd-ui/hint-popover/hint-popover"

export type MenuItemConfig = {
    id          : string
    icon?       : string
    label       : string
    labelWidth? : number
    counter?    : number | string | object
    url?        : string
    moreButton? : any
}

type Props = {
    data        : MenuItemConfig
    selectedId? : string

    showHint?   : boolean

    onClick     : {(id:string):void}

    style?      : any
    className?  : string
}

const debug = false
// const debug = "HorizontalMenuItem"

const HorizontalMenuItem = forwardRef(function (props:Props, ref:any) {

    const selfRef   :any    = useRef()
    const labelRef  :any    = useRef()

    // The component instance will be extended
    // with whatever you return from the callback passed
    // as the second argument
    useImperativeHandle(ref, () => ({
        element : selfRef.current,
        data    : props.data,
    }))

    const checkShowHint = ()=>{
        const computedStyle: any = window.getComputedStyle(labelRef.current)
        const paddingRight = parseInt(computedStyle.getPropertyValue('padding-right'))

        debug && console.log(debug, 'checkShowHint', labelRef.current.scrollWidth, labelRef.current.clientWidth - paddingRight)


        return labelRef.current.scrollWidth > (labelRef.current.clientWidth - paddingRight)
    }

    const onMenuItemClick = (e:any) => {
        e.stopPropagation()

        if (props.onClick) props.onClick(props.data.id)
        else if (props.data.url) gd.goTo(props.data.url)
    };

    const classes = Classes('item', props.className, {
        'no-right-padding'          : !props.data.counter && !props.data.moreButton,
        'with-icon'                 : !!props.data.icon,
        'with-counter fix-counter'  : !!props.data.counter,
        'selected'                  : props.data.id === props.selectedId,
        'with-more'                 : props.data.moreButton
    })

    debug && console.log(debug, 'render', props.data.id === props.selectedId, classes, props)

    const labelStyle:any = {}
    if (props.data?.labelWidth) {
        labelStyle.width = props.data.labelWidth + 'px'
    }

    let counter : any = false
    if (props.data.counter) {

        switch (typeof props.data.counter) {
            case 'object':
                counter = props.data.counter
                break;
            default:
                counter = <div className="ui5-counter">{props.data.counter}</div>
        }
    }

    return (
        <div ref={selfRef} className={classes} style={props.style} onClick={onMenuItemClick}>
            {!!props.data.icon && <div className={Classes("icon", props.data.icon)}/>}
            <div ref        = {labelRef}
                 className  = "label"
                 title      = {props.data.label}
                 style      = {labelStyle}>
                {props.data.label}
            </div>
            {/*title in div above is required for css pseudo element to keep same width for selected and not selected item*/}
            {counter}

            {props.data.moreButton}

            {props.showHint &&
                <HintPopover hint           = {props.data.label}
                             multiline      = {true}
                             checkShowHint  = {checkShowHint}/>}
        </div>
    )
})

export default HorizontalMenuItem
